import React from "react";

export default function LabelContainer({ children, label, placeholder, className = '', style = {}, grow = false, fill = false, row = false }) {
    let s = {}

    if (row) s.flexDirection = 'row';

    let val = label || placeholder;

    const renderComponent = () => {
        if (typeof val === 'string') {
            return <label>{ val }</label>
        }

        if (typeof val === 'object') {
            const Component = val;

            return <label>{ val }</label>
        }
    }

    return (
        <div className={`label-container ${className}`} style={Object.assign({ 
                width: fill ? '100%' : 'inherit',
                flexGrow: grow ? grow : '', 
                ...s,
            }, style)}>
            { (label || placeholder) && renderComponent() }
            { children }
        </div>
    )
}